module.exports = __webpack_public_path__ + "static/other/gameFitFive.37a55b46.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameFitFive.json
// module id = 2382
// module chunks = 0